import EmailTemplateResource from './emailtemplate-resource';
import { update } from 'serializr';
import { mobx, observable, action, computed } from 'mobx';
import _ from 'lodash';
import moment from 'moment';
import Handlebars from 'handlebars';
import Juice from 'juice';
import * as uuide from 'uuid';

class EmailTemplate {
    @observable name;
    @observable body;
    @observable subject;
    templateId;

    constructor() {
        this.templateId = uuide.v4();
    }
}

export default class EmailTemplateStore {
    @observable templates = [];
    @observable styles = [];
    @observable selectedTemplate = null;
    @observable template = new EmailTemplate();
  

    constructor(appStore) {
        this.appStore = appStore;
        this.emailTemplateResource = new EmailTemplateResource();
        this.registerTemplates();
    }

    @action
    async loadTemplates() {
        const token = this.appStore.authStore.getAccessToken();
        const styles = this.emailTemplateResource.loadStyles();
        this.styles.replace(styles);

        const templates = await this.emailTemplateResource.loadTemplates(token);
        this.templates.replace(templates);
    }

    @action
    async saveTemplate(templateModel) {
        const token = this.appStore.authStore.getAccessToken();
        await this.emailTemplateResource.saveTemplate(token, templateModel);
        const i = this.templates.findIndex((t) => t.id === templateModel.id);
        this.templates[i] = templateModel;
    }

    
    @action
    async deleteTemplate(templateModel) {
        
        return await this.saveTemplate(templateModel);
        //return this.emailTemplateResource.deleteTemplate(this.appStore.authStore.getAccessToken(), templateModel);
    }

    inlineContent(body, style) {
        // we only have one.  not likely to change in the near future
        return Juice.inlineContent(body, style);
    }

    @computed
    get style() {
        return this.styles ? this.styles[0] : [];
    }

    registerTemplates() {
        Handlebars.registerHelper('formatDay', function (value, options) {
            const today = moment().locale('en'),
                deadlineDate = moment(value, 'YYYY-MM-DD'),
                dateDiff = deadlineDate.diff(today.format('YYYY-MM-DD'), 'days');

            let text = deadlineDate.format('dddd');
            if (deadlineDate.isSame(today, 'day')) {
                return 'today';
            } else if (dateDiff >= 7 || dateDiff < 0) {
                return deadlineDate.format('dddd, MMMM Do');
            }

            return text;
        });

        Handlebars.registerHelper('dateTenseIsWas', function (value, options) {
            const today = moment().locale('en'),
                deadlineDate = moment(value, 'YYYY-MM-DD'),
                dateDiff = deadlineDate.diff(today.format('YYYY-MM-DD'), 'days');

            if (deadlineDate.isBefore(today, 'day')) {
                return 'was';
            } else if (deadlineDate.isSame(today, 'day')) {
                return 'is';
            } else {
                return 'is';
            }
        });

        Handlebars.registerHelper('dateTenseWereAre', function (value, options) {
            const today = moment().locale('en'),
                deadlineDate = moment(value, 'YYYY-MM-DD'),
                dateDiff = deadlineDate.diff(today.format('YYYY-MM-DD'), 'days');

            if (deadlineDate.isBefore(today, 'day')) {
                return 'were';
            } else if (deadlineDate.isSame(today, 'day')) {
                return 'are';
            } else {
                return 'are';
            }
        });
    }

    /**
     *
     * @param template (Selected template)
     * @param data
     */
    renderTemplate(template, data, style = '') {
        const subjectCompiled = Handlebars.compile(template.subject),
            bodyCompiled = Handlebars.compile(template.body);
        return {
            subject: subjectCompiled(data),
            body: this.inlineContent(bodyCompiled(data), style),
        };
    }
    
    createNewStepState(token, template) {
        return this.post(token, template).then(({ body }) => {
            return this.getStepStateById(token, body.workflowStepStateId);
        });
    }
    async createTemplate(template,tags,emailsTo,emailsCC) {
        this.isLoading = true;
        const token = this.appStore.authStore.getAccessToken();

        return await this.emailTemplateResource.createTemplate(token, template,tags,emailsTo,emailsCC)
            .then(dataURI => {
                this.isLoading = false;
                return Promise.resolve(dataURI);
            })
            .catch(error => {
                this.isLoading = false;
                return Promise.reject(error);
            });
    }
   
    resetTemplate() {
        this.template = new EmailTemplate();
    }
}



// WEBPACK FOOTER //
// ./src/template/emailtemplate-store.js